/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import React, {
  createRef,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { defaultFormValues } from "./defaultFormValues";
import {
  fetchActivitiesList,
  fetchAllProjects,
  fetchUsersList,
} from "../Envirornmental Surveying/fetchData";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  fetchDescriptionOfSurveySiteList,
  fetchPermitClosureReasonList,
} from "./fetchData";
import PhotoUpload from "../Vehicle-assessment/PhotoUpload/photoUpload";
import { MultiSelect } from "primereact/multiselect";
import PermitSignaturesComponent from "./permitSignaturesComponent";
import { SignaturePadRef } from "../Add Risk Assessment/SignaturePadComponent";
import { InputTextarea } from "primereact/inputtextarea";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import axios from "../../../../util/axiosconfig";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { dataURLToFile } from "../helper/helperFunctions";
import { Image } from "primereact/image";
import { Calendar } from "primereact/calendar";
import { convertDateToEpoch } from "../../../../helper/DateConverters";
import EnvSignaturesInPermit, { formatDate } from "./envSignaturesInPermit";
import { formatDateTime } from "../Job Sheet Belfast/ViewBelfastForm";
import { PermitSignatureContext } from "../Envirornmental Surveying/PermitSignatureContext";

interface TableRow {
  hazard: string;
  control: string;
  hazardRowSpan: number;
  hazardYes: boolean | null;
  hazardNo: boolean | null;
  controlYes: boolean | null;
  controlNo: boolean | null;
}

interface HazardGroup {
  hazard: string;
  controls: string[];
}

const HazardRow = ({
  hazard,
  onHazardChange,
  hazardYes,
  hazardNo,
  disabled,
  isPermitSpaceFormAttached,
}: any) => {
  return (
    <tr>
      <td className="tw-align-top tw-font-medium tw-p-2 tw-border tw-bg-gray-200">
        {hazard}
      </td>
      <td className="tw-p-2 tw-border">
        <RadioButton
          name={`hazard-${hazard}`}
          checked={hazardYes === true}
          onChange={() => onHazardChange(true)}
          disabled={disabled || isPermitSpaceFormAttached}
        />
      </td>
      <td className="tw-p-2 tw-border">
        <RadioButton
          name={`hazard-${hazard}`}
          checked={hazardNo === true}
          onChange={() => onHazardChange(false)}
          disabled={disabled || isPermitSpaceFormAttached}
        />
      </td>
    </tr>
  );
};

const ControlMeasureRow = ({
  control,
  onControlChange,
  controlYes,
  controlNo,
  disabled,
  isPermitSpaceFormAttached,
}: any) => {
  return (
    <tr>
      <td className="tw-pl-6 tw-font-medium tw-p-2 tw-border">• {control}</td>
      <td className="tw-p-2 tw-border">
        <RadioButton
          name={`control-${control}`}
          checked={controlYes === true}
          onChange={() => onControlChange(true)}
          disabled={disabled || isPermitSpaceFormAttached}
        />
      </td>
      <td className="tw-p-2 tw-border">
        <RadioButton
          name={`control-${control}`}
          checked={controlNo === true}
          onChange={() => onControlChange(false)}
          disabled={disabled || isPermitSpaceFormAttached}
        />
      </td>
    </tr>
  );
};

const AddPermitSpaceEntryForm = ({
  projectKeyName,
  formValues,
  setFormValues,
  isUploadInProgress,
  setIsUploadInProgress,
  images,
  setImages,
  fileValues,
  setFileValues,
  timeStampLocationValues,
  setTimeStampLocationValues,
  selectedDescriptionOfSurveySite,
  setSelectedDescriptionOfSurveySite,
  selectedPermitClosureReason,
  setSelectedPermitClosureReason,
  selectedPurposeOfEntry,
  setSelectedPurposeOfEntry,
  selectedNames,
  setSelectedNames,
  permitStartDateTime,
  setPermitStartDateTime,
  permitEndDateTime,
  setPermitEndDateTime,
  isPermitSpaceFormAttached,
  showAttachedFiles,
  teamMember1,
  teamMember2,
  additionalTeamMembers,
  signatureDataURLs,
  envEntrantTopmans,
  setEnvEntrantTopmans,
  permitSignatureFiles,
  setPermitSignatureFiles,
}: any) => {
  const context = useContext(PermitSignatureContext);

  if (!context) {
    throw new Error("FilterPage must be used within a FilterProvider");
  }

  const {
    permitApprovalRefs,
    setPermitApprovalRefs,
    permitClosureRefs,
    setPermitClosureRefs,
    permitSignatureDataUrl,
  } = context;

  useEffect(() => {
    if (
      permitSignatureDataUrl &&
      permitSignatureDataUrl.permitApproval &&
      Array.isArray(permitSignatureDataUrl.permitApproval)
    ) {
      permitSignatureDataUrl.permitApproval.forEach(
        (dataUrl: string, idx: number) => {
          if (permitApprovalRefs[idx]?.current && dataUrl) {
            permitApprovalRefs[idx].current.fromDataURL(dataUrl);
          }
        }
      );
    }
    if (
      permitSignatureDataUrl &&
      permitSignatureDataUrl.permitClosure &&
      Array.isArray(permitSignatureDataUrl.permitClosure)
    ) {
      permitSignatureDataUrl.permitClosure.forEach(
        (dataUrl: string, idx: number) => {
          if (permitClosureRefs[idx]?.current && dataUrl) {
            permitClosureRefs[idx].current.fromDataURL(dataUrl);
          }
        }
      );
    }
  }, [permitSignatureDataUrl, permitApprovalRefs, permitClosureRefs]);
  const toast = useRef<Toast>(null);
  const navigate = useNavigate();
  const [formSubmitting, setFormSubmitting] = useState(false);

  const [isDataloading, setIsDataLoading] = useState(false);
  const [activitiesList, setActivitiesList] = useState<any>([]);
  const [descriptionOfSurveySiteList, setDescriptionOfSurveySiteList] =
    useState<any[]>([]);
  const [permitClosureReasonList, setPermitClosureReasonList] = useState<any[]>(
    []
  );
  const [usersList, setUsersList] = useState<any[]>([]);

  const ImageNotAvailable = process.env.REACT_APP_IMAGE_NOT_FOUND_URL || "";

  const icon = (
    <i
      className="pi pi-eye tw-text-white tw-h-full tw-w-full tw-justify-center tw-items-center tw-flex"
      style={{
        backgroundColor: "black",
        opacity: 0.5,
        transition: "opacity 0.3s ease",
      }}
    ></i>
  );

  const [localFormValues, setLocalFormValues] = useState(defaultFormValues);
  const [localImages, setLocalImages] = useState<Record<string, File>>({});
  const [localPermitApprovalRefs, setLocalPermitApprovalRefs] = useState<
    React.RefObject<SignaturePadRef>[]
  >([]);
  const [localPermitClosureRefs, setLocalPermitClosureRefs] = useState<
    React.RefObject<SignaturePadRef>[]
  >([]);
  const [localFileValues, setLocalFileValues] = useState<any[]>([]);
  const [localTimeStampLocationValues, setLocalTimeStampLocationValues] =
    useState({
      locations: [],
      timeStamps: [],
    });

  const [allProjects, setAllProjects] = useState<any[]>([]);
  const [selectedProject, setSelectedProject] = useState<any>(null);
  const [
    localSelectedDescriptionOfSurveySite,
    setLocalSelectedDescriptionOfSurveySite,
  ] = useState<any>(null);
  const [
    localSelectedPermitClosureReason,
    setLocalSelectedPermitClosureReason,
  ] = useState<any>(null);
  const [localSelectedPurposeOfEntry, setLocalSelectedPurposeOfEntry] =
    useState<any>(null);
  const [localSelectedNames, setLocalSelectedNames] = useState<any[]>([]);
  const [localPermitStartDateTime, setLocalPermitStartDateTime] =
    useState<any>(null);
  const [localPermitEndDateTime, setLocalPermitEndDateTime] =
    useState<any>(null);

  const preEntryChecksData: HazardGroup[] =
    defaultFormValues.preEntryChecks.map((check) => ({
      hazard: check.label,
      controls: check.controlMeasure.map((control) => control.label),
    }));

  const initialData: TableRow[] = preEntryChecksData.flatMap((group) =>
    group.controls.map((control, index) => ({
      hazard: group.hazard,
      control,
      hazardRowSpan: index === 0 ? group.controls.length : 0,
      hazardYes: null,
      hazardNo: null,
      controlYes: null,
      controlNo: null,
    }))
  );

  const getEntrantTopman = (user: any, type: string) => {
    return (
      attachedEntrantTopMans[type].find(
        (u: any) => u.userID.toString() === user.userID.toString()
      )?.value || "N/A"
    );
  };

  const getDisplayDate = (epochValue: any): Date | null => {
    if (!epochValue) return null;
    if (epochValue instanceof Date) return epochValue;
    if (typeof epochValue === "number") {
      return new Date(epochValue * 1000);
    }
    return null;
  };

  const [isSiteSetupUploadInProgress, setIsSiteSetupUploadInProgress] =
    useState(false);

  const isStandaloneMode = formValues === undefined || formValues === null;

  const envUsers = [
    ...(teamMember1?.userID ? [teamMember1] : []),
    ...(teamMember2?.userID ? [teamMember2] : []),
    ...(additionalTeamMembers ?? []),
  ];
  const currentFormValues = isStandaloneMode ? localFormValues : formValues;
  const currentImages = images !== undefined ? images : localImages;
  const currentPermitApprovalRefs =
    permitApprovalRefs !== undefined
      ? permitApprovalRefs
      : localPermitApprovalRefs;

  const [attachedEntrantTopMans, setAttachedEntrantTopMans] = useState<any>({
    approvalOfPermit: [],
    permitClosure: [],
  });
  const currentPermitClosureRefs =
    permitClosureRefs !== undefined
      ? permitClosureRefs
      : localPermitClosureRefs;

  const currentFileValues =
    fileValues !== undefined ? fileValues : localFileValues;
  const currentTimeStampLocationValues =
    timeStampLocationValues !== undefined
      ? timeStampLocationValues
      : localTimeStampLocationValues;

  const currentSelectedDescriptionOfSurveySite =
    selectedDescriptionOfSurveySite !== undefined
      ? selectedDescriptionOfSurveySite
      : localSelectedDescriptionOfSurveySite;
  const currentSelectedPermitClosureReason =
    selectedPermitClosureReason !== undefined
      ? selectedPermitClosureReason
      : localSelectedPermitClosureReason;
  const currentSelectedPurposeOfEntry =
    selectedPurposeOfEntry !== undefined
      ? selectedPurposeOfEntry
      : localSelectedPurposeOfEntry;
  const currentSelectedNames =
    selectedNames !== undefined ? selectedNames : localSelectedNames;

  const currentSelectedPermitStartDateTime =
    permitStartDateTime !== undefined
      ? permitStartDateTime
      : localPermitStartDateTime;
  const currentSelectedPermitEndDateTime =
    permitEndDateTime !== undefined
      ? permitEndDateTime
      : localPermitEndDateTime;

  const getSignaturesByType = (type: "approval" | "closure") => {
    const sigs = showAttachedFiles.signatures.filter((sig: any) =>
      sig.originalname.includes(`_sig_${type}`)
    );
    return sigs.sort((a: any, b: any) => {
      const aId = a.originalname.split("_")[0];
      const bId = b.originalname.split("_")[0];
      const aIndex = currentFormValues.name.findIndex(
        (n: any) => n.userID.toString() === aId
      );
      const bIndex = currentFormValues.name.findIndex(
        (n: any) => n.userID.toString() === bId
      );
      return aIndex - bIndex;
    });
    // const sigs = showAttachedFiles.signatures.filter((sig: any) =>
    //   sig.originalname.includes(`_sig_${type}`)
    // );

    // const envUserIds = (envUsers || []).map((u: any) => u.userID?.toString());
    // const filteredSigs = sigs.filter((sig: any) => {
    //   const userId = sig.originalname.split("_")[0];
    //   return !envUserIds.includes(userId);
    // });

    // return filteredSigs.sort((a: any, b: any) => {
    //   const aId = a.originalname.split("_")[0];
    //   const bId = b.originalname.split("_")[0];
    //   const aIndex = currentFormValues.name.findIndex(
    //     (n: any) => n.userID.toString() === aId
    //   );
    //   const bIndex = currentFormValues.name.findIndex(
    //     (n: any) => n.userID.toString() === bId
    //   );
    //   return aIndex - bIndex;
    // });
  };

  const approvalSignatures = isPermitSpaceFormAttached
    ? getSignaturesByType("approval")
    : [];
  const closureSignatures = isPermitSpaceFormAttached
    ? getSignaturesByType("closure")
    : [];

  const currentSetFormValues = isStandaloneMode
    ? setLocalFormValues
    : setFormValues;
  const currentSetImages = setImages !== undefined ? setImages : setLocalImages;
  const currentSetPermitApprovalRefs =
    setPermitApprovalRefs !== undefined
      ? setPermitApprovalRefs
      : setLocalPermitApprovalRefs;
  const currentSetPermitClosureRefs =
    setPermitClosureRefs !== undefined
      ? setPermitClosureRefs
      : setLocalPermitClosureRefs;
  const currentSetFileValues =
    setFileValues !== undefined ? setFileValues : setLocalFileValues;
  const currentSetTimeStampLocationValues =
    setTimeStampLocationValues !== undefined
      ? setTimeStampLocationValues
      : setLocalTimeStampLocationValues;

  const currentSetSelectedDescriptionOfSurveySite =
    setSelectedDescriptionOfSurveySite !== undefined
      ? setSelectedDescriptionOfSurveySite
      : setLocalSelectedDescriptionOfSurveySite;
  const currentSetSelectedPermitClosureReason =
    setSelectedPermitClosureReason !== undefined
      ? setSelectedPermitClosureReason
      : setLocalSelectedPermitClosureReason;
  const currentSetSelectedPurposeOfEntry =
    setSelectedPurposeOfEntry !== undefined
      ? setSelectedPurposeOfEntry
      : setLocalSelectedPurposeOfEntry;
  const currentSetSelectedNames =
    setSelectedNames !== undefined ? setSelectedNames : setLocalSelectedNames;
  const currentSetSelectedPermitStartDateTime =
    setPermitStartDateTime !== undefined
      ? setPermitStartDateTime
      : setLocalPermitStartDateTime;
  const currentSetSelectedPermitEndDateTime =
    setPermitEndDateTime !== undefined
      ? setPermitEndDateTime
      : setLocalPermitEndDateTime;

  const populatedData: TableRow[] = currentFormValues?.preEntryChecks
    ? currentFormValues.preEntryChecks.flatMap((check: any) =>
        check.controlMeasure.map((control: any, idx: number) => ({
          hazard: check.label,
          control: control.label,
          hazardRowSpan: idx === 0 ? check.controlMeasure.length : 0,
          hazardYes: check.value === "yes",
          hazardNo: check.value === "no" || check.value === "n_a",
          controlYes: control.value === "yes",
          controlNo: control.value === "no" || control.value === "n_a",
        }))
      )
    : initialData;

  const [data, setData] = useState<TableRow[]>(
    isStandaloneMode ? initialData : populatedData
  );

  useEffect(() => {
    if (
      !isStandaloneMode &&
      !formValues &&
      typeof setFormValues === "function"
    ) {
      setFormValues(defaultFormValues);
    }
  }, [formValues, setFormValues, isStandaloneMode]);

  const safeSetFormValues = (updater: any) => {
    if (typeof currentSetFormValues === "function") {
      currentSetFormValues(updater);
    }
  };

  const safeSetImages = (updater: any) => {
    if (typeof currentSetImages === "function") {
      currentSetImages(updater);
    }
  };

  const safeSetPermitApprovalRefs = (updater: any) => {
    if (typeof currentSetPermitApprovalRefs === "function") {
      currentSetPermitApprovalRefs(updater);
    }
  };

  const safeSetPermitClosureRefs = (updater: any) => {
    if (typeof currentSetPermitClosureRefs === "function") {
      currentSetPermitClosureRefs(updater);
    }
  };

  const safeSetFileValues = (updater: any) => {
    if (typeof currentSetFileValues === "function") {
      currentSetFileValues(updater);
    }
  };

  const safeSetTimeStampLocationValues = (updater: any) => {
    if (typeof currentSetTimeStampLocationValues === "function") {
      currentSetTimeStampLocationValues(updater);
    }
  };

  const safeSetSelectedDescriptionOfSurveySite = (updater: any) => {
    if (typeof currentSetSelectedDescriptionOfSurveySite === "function") {
      currentSetSelectedDescriptionOfSurveySite(updater);
    }
  };

  const safeSetSelectedPermitClosureReason = (updater: any) => {
    if (typeof currentSetSelectedPermitClosureReason === "function") {
      currentSetSelectedPermitClosureReason(updater);
    }
  };

  const safeSetSelectedPurposeOfEntry = (updater: any) => {
    if (typeof currentSetSelectedPurposeOfEntry === "function") {
      currentSetSelectedPurposeOfEntry(updater);
    }
  };

  const safeSetSelectedNames = (updater: any) => {
    if (typeof currentSetSelectedNames === "function") {
      currentSetSelectedNames(updater);
    }
  };

  const safeSetSelectedPermitStartDateTime = (updater: any) => {
    if (typeof currentSetSelectedPermitStartDateTime === "function") {
      currentSetSelectedPermitStartDateTime(updater);
    }
  };

  const safeSetSelectedPermitEndDateTime = (updater: any) => {
    if (typeof currentSetSelectedPermitEndDateTime === "function") {
      currentSetSelectedPermitEndDateTime(updater);
    }
  };
  const handleTimeChange = (name: string, value: any) => {
    const timeFields = ["permitStartDateAndTime", "permitEndDateAndTime"];

    let processedValue = value;
    if (timeFields.includes(name) && value instanceof Date) {
      processedValue = convertDateToEpoch(value);
    }

    safeSetFormValues((prev: any) => ({
      ...prev,
      [name]: processedValue,
    }));
  };

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Function to clear all signatures
  const clearAllSignatures = useCallback(() => {
    // Don't clear signatures on initial load
    if (isInitialLoad) return;

    // Clear all permit user's signatures
    currentPermitApprovalRefs.forEach((ref: any) => {
      if (ref.current) {
        ref.current.clear();
      }
    });

    currentPermitClosureRefs.forEach((ref: any) => {
      if (ref.current) {
        ref.current.clear();
      }
    });
  }, [
    currentFormValues?.name,
    isInitialLoad,
    currentPermitApprovalRefs,
    currentPermitClosureRefs,
  ]);

  // Clear signatures when form values change
  useEffect(() => {
    clearAllSignatures();
  }, [
    currentFormValues?.project,
    currentFormValues?.name,
    currentFormValues?.site,
    currentFormValues?.surveySiteDescription,
    currentFormValues?.surveySiteDescriptionComment,
    currentFormValues?.purposeOfEntry,
    currentFormValues?.preEntryChecks,
    currentFormValues?.safetyEssentialEquipmentCheck,
    // currentFormValues?.entrantTopmans?.approvalOfPermit,
    // currentFormValues?.entrantTopmans?.permitClosure,
    currentFormValues?.permitClosureReason,
    currentFormValues?.commentsIfAny,
    currentFormValues?.permitStartDateAndTime,
    currentFormValues?.permitEndDateAndTime,
    clearAllSignatures,
  ]);

  // Clear signatures when photos change
  useEffect(() => {
    clearAllSignatures();
  }, [currentFileValues, clearAllSignatures]);

  useEffect(() => {
    fetchUsersList(setUsersList, toast, setIsDataLoading);
    fetchDescriptionOfSurveySiteList(
      setDescriptionOfSurveySiteList,
      setIsDataLoading,
      toast
    );
    fetchActivitiesList(setActivitiesList, toast, setIsDataLoading);
    fetchPermitClosureReasonList(
      setPermitClosureReasonList,
      setIsDataLoading,
      toast
    );
    if (isStandaloneMode) {
      fetchAllProjects(setAllProjects, toast, setIsDataLoading);
    }
    if (isPermitSpaceFormAttached) {
      setAttachedEntrantTopMans(currentFormValues.entrantTopmans);
      // safeSetFormValues((prev: any) => ({
      //   ...prev,
      //   entrantTopmans: {
      //     approvalOfPermit: [],
      //     permitClosure: [],
      //   },
      // }));
    }
    setIsInitialLoad(false);
  }, []);

  // Create refs for permit approval signatures
  useEffect(() => {
    safeSetPermitApprovalRefs((prevRefs: any) => {
      const newRefs = [...prevRefs];
      const totalUsers = [...currentFormValues.name, ...(envUsers || [])]
        .length;
      while (newRefs.length < totalUsers) {
        newRefs.push(createRef<SignaturePadRef>());
      }
      while (newRefs.length > totalUsers) {
        newRefs.pop();
      }
      return newRefs;
    });
  }, [currentFormValues.name.length]); // Add envUsers dependency

  useEffect(() => {
    safeSetPermitClosureRefs((prevRefs: any) => {
      const newRefs = [...prevRefs];
      while (newRefs.length < currentFormValues.name.length) {
        newRefs.push(createRef<SignaturePadRef>());
      }
      while (newRefs.length > currentFormValues.name.length) {
        newRefs.pop();
      }
      return newRefs;
    });
  }, [currentFormValues.name.length]);

  const isUploading =
    (isUploadInProgress ? isUploadInProgress : isSiteSetupUploadInProgress) ||
    formSubmitting ||
    isDataloading;

  const projectKeyNameOptionsTemplate = (option: any) => {
    return (
      <div>
        {option.projectKey} - {option.name}
      </div>
    );
  };

  const projectKeyNameValueTemplate = (option: any) => {
    if (!option) {
      return "Select a Project";
    }
    return (
      <div>
        {option.projectKey} - {option.name}
      </div>
    );
  };

  const getSitePhoto = (label: string) => {
    const photo =
      showAttachedFiles?.siteSetupPhotos &&
      showAttachedFiles?.siteSetupPhotos?.find((img: any) =>
        img.originalname
          .replace(".png", "")
          .toLowerCase()
          .includes(label.toLowerCase())
      );
    return photo?.file || ImageNotAvailable;
  };

  const getPhotoMeta = (photoKey: string) => {
    const locationObj = currentTimeStampLocationValues?.locations?.find(
      (loc: any) => loc.photoKey === photoKey
    );
    const timeObj = currentTimeStampLocationValues?.timeStamps?.find(
      (t: any) => t.photoKey === photoKey
    );
    return {
      address: locationObj?.address || "",
      timestamp: timeObj?.timestamp || "",
    };
  };

  const validateForm = () => {
    if (
      !currentFormValues?.project ||
      currentFormValues?.project.trim() === ""
    ) {
      showError("Project Value is required", toast);
      return false;
    }
    if (!currentFormValues?.name || currentFormValues?.name.length === 0) {
      showError("Atleast one name is required", toast);
      return false;
    }
    if (!currentFormValues?.site || currentFormValues?.site.trim() === "") {
      showError("Site is required", toast);
      return false;
    }

    if (!currentFormValues?.surveySiteDescription) {
      showError("Description of Survey Site is required", toast);
      return false;
    }

    if (
      currentFormValues?.surveySiteDescription &&
      currentFormValues?.surveySiteDescription === "Other" &&
      (!currentFormValues?.surveySiteDescriptionComment ||
        currentFormValues?.surveySiteDescriptionComment.trim() === "")
    ) {
      showError(
        "Comments are required when survey site description is 'Other'",
        toast
      );
      return false;
    }

    if (!currentFormValues?.purposeOfEntry) {
      showError("Purpose of Entry is required", toast);
      return false;
    }

    const preEntryChecksUnselected = currentFormValues?.preEntryChecks?.some(
      (item: any) => !item.value
    );
    if (preEntryChecksUnselected) {
      showError(
        "Please select Yes/No/N/A for all Pre-Entry Checks items.",
        toast
      );
      return false;
    }

    for (let group of preEntryChecksData) {
      const hazardRow = data.find(
        (row: any) => row.hazard === group.hazard && row.hazardRowSpan > 0
      );
      if (hazardRow?.hazardYes) {
        for (let control of group.controls) {
          const controlRow = data.find(
            (row: any) => row.hazard === group.hazard && row.control === control
          );
          if (
            controlRow &&
            controlRow.controlYes !== true &&
            controlRow.controlNo !== true
          ) {
            showError(
              `Please select Yes/No for all control measures under hazard "${group.hazard}".`,
              toast
            );
            return false;
          }
        }
      }
    }

    const safetyEssentialEquipmentCheckUnselected =
      currentFormValues?.safetyEssentialEquipmentCheck?.some(
        (item: any) => !item.value
      );
    if (safetyEssentialEquipmentCheckUnselected) {
      showError(
        "Please select Yes/No/N/A for all Safety Essential Equipment Check items.",
        toast
      );
      return false;
    }

    if (
      !currentFileValues.some(
        (file: any) =>
          file.photoKey && file.photoKey.toLowerCase().includes("site_setup-1")
      )
    ) {
      showError("Please upload the Site Setup 1 photograph.", toast);
      return false;
    }
    if (
      !currentFileValues.some(
        (file: any) =>
          file.photoKey && file.photoKey.toLowerCase().includes("site_setup-2")
      )
    ) {
      showError("Please upload the Site Setup 2 photograph.", toast);
      return false;
    }

    if (!currentFormValues?.permitClosureReason) {
      showError("Permit Closure Reason is required", toast);
      return false;
    }

    if (
      currentFormValues?.permitClosureReason &&
      currentFormValues?.permitClosureReason === "Confined Spaces Aborted" &&
      (!currentFormValues?.commentsIfAny ||
        currentFormValues?.commentsIfAny.trim() === "")
    ) {
      showError(
        "Comments are required when permit closure reason is 'Confined Spaces Aborted'",
        toast
      );
      return false;
    }
    if (!currentFormValues?.permitStartDateAndTime) {
      showError("Permit Start Date and Time is required", toast);
      return false;
    }

    if (!currentFormValues?.permitEndDateAndTime) {
      showError("Permit End Date and Time is required", toast);
      return false;
    }

    // Validate that start time is not greater than end time
    if (
      currentFormValues.permitStartDateAndTime &&
      currentFormValues.permitEndDateAndTime
    ) {
      const permitStartDateAndTime = new Date(
        currentFormValues.permitStartDateAndTime
      ).getTime();
      const permitEndDateAndTime = new Date(
        currentFormValues.permitEndDateAndTime
      ).getTime();

      if (permitStartDateAndTime > permitEndDateAndTime) {
        showError(
          "Permit End Time must not be earlier than Permit Start Time",
          toast
        );
        return false;
      }
    }

    for (let i = 0; i < currentFormValues.name.length; i++) {
      const approvalRef = currentPermitApprovalRefs[i]?.current;
      const closureRef = currentPermitClosureRefs[i]?.current;
      if (approvalRef?.isEmpty()) {
        showError(
          `Signature required for approval by ${
            currentFormValues.name[i]?.displayName || "User " + (i + 1)
          }`,
          toast
        );
        return false;
      }
      if (closureRef?.isEmpty()) {
        showError(
          `Signature required for closure by ${
            currentFormValues.name[i]?.displayName || "User " + (i + 1)
          }`,
          toast
        );
        return false;
      }
    }

    for (let i = 0; i < currentFormValues.name.length; i++) {
      const user = currentFormValues.name[i];
      const entrantTopmanApproval =
        currentFormValues.entrantTopmans?.approvalOfPermit?.find(
          (et: any) => et.userID?.toString() === user.userID?.toString()
        );
      const entrantTopmanClosure =
        currentFormValues.entrantTopmans?.permitClosure?.find(
          (et: any) => et.userID?.toString() === user.userID?.toString()
        );
      if (!entrantTopmanApproval || !entrantTopmanApproval.value) {
        showError(
          `Entrant/Topman is required for approval signature of ${
            user.displayName || "User " + (i + 1)
          }`,
          toast
        );
        return false;
      }
      if (!entrantTopmanClosure || !entrantTopmanClosure.value) {
        showError(
          `Entrant/Topman is required for closure signature of ${
            user.displayName || "User " + (i + 1)
          }`,
          toast
        );
        return false;
      }
    }

    return true; // Return true if valid, false otherwise
  };

  const handleSave = async () => {
    // Logic to save the form data
    try {
      if (!validateForm()) {
        return;
      }
      setFormSubmitting(true);
      setIsUploadInProgress && setIsUploadInProgress(true);
      setIsSiteSetupUploadInProgress(true);
      // Prepare FormData
      const formData = new FormData();

      // 1. Process signatures
      const permitApprovalSignatures: File[] = [];
      const permitClosureSignatures: File[] = [];
      const photosArray: File[] = [];

      // Process additional team members signatures
      currentFileValues.forEach((photoItem: any) => {
        if (photoItem?.photoKey && photoItem?.file) {
          const fileName = `${photoItem.photoKey}.png`;
          const dataURL = new Blob([photoItem.file], {
            type: "image/png",
          });
          const photoFile = new File([dataURL], fileName, {
            type: "image/png",
          });
          photosArray.push(photoFile);
        }
      });

      photosArray.forEach((file, index) => {
        formData.append("siteSetupPhotos", file);
      });

      // Process additional team members signatures
      currentFormValues.name.forEach((member: any, index: number) => {
        const ref = currentPermitApprovalRefs[index];
        if (ref.current && !ref.current.isEmpty() && member.userID) {
          const signatureDataUrl = ref.current.toDataURL();
          const signatureFile = dataURLToFile(
            signatureDataUrl,
            `${member.userID}_sig_approval.png`
          );
          if (signatureFile) {
            permitApprovalSignatures.push(signatureFile);
          }
        }
      });

      // Add all signatures to FormData
      permitApprovalSignatures.forEach((file, index) => {
        formData.append(`signatures`, file);
      });

      // Process additional team members signatures
      currentFormValues.name.forEach((member: any, index: number) => {
        const ref = currentPermitClosureRefs[index];
        if (ref.current && !ref.current.isEmpty() && member.userID) {
          const signatureDataUrl = ref.current.toDataURL();
          const signatureFile = dataURLToFile(
            signatureDataUrl,
            `${member.userID}_sig_closure.png`
          );
          if (signatureFile) {
            permitClosureSignatures.push(signatureFile);
          }
        }
      });

      permitClosureSignatures.forEach((file, index) => {
        formData.append(`signatures`, file);
      });

      formData.append("formJson", JSON.stringify(currentFormValues));
      formData.append(
        "timeStampLocationJson",
        JSON.stringify(currentTimeStampLocationValues)
      );
      formData.append("isWeb", "true");

      const response = await axios.post(
        "health-and-safety/permit-confined-space-entry-form ",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setFormSubmitting(false);
      showSuccess(response.data.Message, toast);
      setIsUploadInProgress && setIsUploadInProgress(false);
      setIsSiteSetupUploadInProgress(false);
      navigate("/layout/health-and-safety/permit-for-confined-space-entry");
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setIsUploadInProgress && setIsUploadInProgress(false);
      setIsSiteSetupUploadInProgress(false);
      setFormSubmitting(false);
      showError(errorMessage, toast);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="tw-border-solid tw-border tw-border-[#E2E2e2] tw-rounded-lg tw-relative tw-bg-white ">
        {isStandaloneMode && (
          <div className="tw-bg-[#F8FAFC] tw-p-4 tw-rounded-t-lg tw-border-b-[1px] tw-border-[#E2E8F0] tw-flex tw-justify-between tw-items-center">
            <h2 className="tw-text-lg sm:tw-text-xl xl:tw-text-2xl tw-font-semibold tw-text-[#101828]">
              Permit for Confined Space Entry
            </h2>
          </div>
        )}

        <div>
          <div className="tw-p-2 sm:tw-p-4">
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 2xl:tw-grid-cols-3 tw-gap-6 tw-w-full">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label" htmlFor="teamMember1">
                  Project
                </label>
                {isStandaloneMode ? (
                  <Dropdown
                    className={`tw-border tw-border-solid tw-border-gray-300 tw-h-11 tw-rounded-md placeholder:tw-font-normal tw-w-full`}
                    value={selectedProject ?? null}
                    options={allProjects}
                    itemTemplate={projectKeyNameOptionsTemplate}
                    valueTemplate={projectKeyNameValueTemplate}
                    onChange={(e) => {
                      setSelectedProject(e.value);
                      safeSetFormValues((prevValues: any) => ({
                        ...prevValues,
                        project: `${e.value.projectKey} - ${e.value.name}`,
                      }));
                    }}
                    disabled={isUploading}
                    placeholder="Select a Project"
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => {
                      if (
                        e.key === " " ||
                        e.key === "Enter" ||
                        e.key === "ArrowUp" ||
                        e.key === "ArrowDown"
                      ) {
                        e.stopPropagation();
                      }
                    }}
                    filterBy="projectKey,name"
                    filterMatchMode="contains"
                    filter
                  />
                ) : (
                  <InputText
                    type="text"
                    value={
                      (isPermitSpaceFormAttached
                        ? currentFormValues?.project
                        : projectKeyName) ?? "N/A"
                    }
                    readOnly
                    className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  />
                )}
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start ">
                <label className="leak-label" htmlFor="teamMember1">
                  Name
                </label>
                {isPermitSpaceFormAttached ? (
                  <InputText
                    type="text"
                    value={
                      currentFormValues?.name
                        ?.map((user: any) => user.displayName)
                        .join(", ") || "N/A"
                    }
                    readOnly
                    className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  />
                ) : (
                  <MultiSelect
                    id="addteamname"
                    maxSelectedLabels={2}
                    selectAllLabel="Select All"
                    placeholder="Select Names"
                    value={currentSelectedNames}
                    onChange={(e) => {
                      safeSetSelectedNames(e.value);
                      safeSetFormValues((prevValues: any) => ({
                        ...prevValues,
                        name: e.value.map((user: any) => ({
                          userID: user.userID,
                          displayName: user.displayName,
                        })),
                      }));
                    }}
                    disabled={isUploading}
                    options={usersList}
                    optionLabel="displayName"
                    filter
                    className="custome-multiselect !tw-w-full tw-h-10 sm:tw-h-11 tw-text-sm sm:tw-text-base"
                  />
                )}
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label" htmlFor="teamMember1">
                  Site
                </label>
                <InputText
                  type="text"
                  value={currentFormValues?.site ?? ""}
                  onChange={(e) => {
                    safeSetFormValues((prevValues: any) => ({
                      ...prevValues,
                      site: e.target.value,
                    }));
                  }}
                  readOnly={isPermitSpaceFormAttached}
                  disabled={isUploading}
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-w-full">
                <label className="leak-label" htmlFor="teamMember1">
                  Description Of Survey Site
                </label>
                {isPermitSpaceFormAttached ? (
                  <InputText
                    type="text"
                    value={currentFormValues?.surveySiteDescription || "N/A"}
                    readOnly
                    className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  />
                ) : (
                  <Dropdown
                    id="teamMember1"
                    placeholder="Select description of survey site"
                    value={currentSelectedDescriptionOfSurveySite}
                    onChange={(e) => {
                      safeSetSelectedDescriptionOfSurveySite(e.value);
                      safeSetFormValues((prevValues: any) => ({
                        ...prevValues,
                        surveySiteDescription: e.value.siteName,
                      }));
                      if (e.value.siteName !== "Other") {
                        safeSetFormValues((prevValues: any) => ({
                          ...prevValues,
                          surveySiteDescriptionComment: null,
                        }));
                      }
                    }}
                    disabled={isUploading}
                    options={descriptionOfSurveySiteList ?? []}
                    optionLabel="siteName"
                    filter
                    className="custome-dropdown !tw-w-full  tw-h-10 sm:tw-h-11 tw-text-sm sm:tw-text-base"
                  />
                )}
              </div>
              {currentFormValues?.surveySiteDescription === "Other" && (
                <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-w-full tw-justify-start tw-col-span">
                  <label className="leak-label">Comments: </label>
                  <InputTextarea
                    rows={1}
                    value={currentFormValues.surveySiteDescriptionComment ?? ""}
                    onChange={(e) =>
                      safeSetFormValues((prevValues: any) => ({
                        ...prevValues,
                        surveySiteDescriptionComment: e.target.value,
                      }))
                    }
                    readOnly={isPermitSpaceFormAttached}
                    disabled={isUploading}
                    placeholder="Enter Comments: "
                    className="tw-pl-2 tw-border !tw-w-full tw-border-gray-300 tw-rounded-md tw-text-[#667085] "
                  />
                </div>
              )}
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label" htmlFor="teamMember1">
                  Purpose of Entry
                </label>
                {isPermitSpaceFormAttached ? (
                  <InputText
                    type="text"
                    value={currentFormValues?.purposeOfEntry || "N/A"}
                    readOnly
                    className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  />
                ) : (
                  <Dropdown
                    id="teamMember1"
                    placeholder="Select purpose of entry"
                    value={currentSelectedPurposeOfEntry}
                    onChange={(e) => {
                      safeSetSelectedPurposeOfEntry(e.value);
                      safeSetFormValues((prevValues: any) => ({
                        ...prevValues,
                        purposeOfEntry: e.value.name,
                      }));
                    }}
                    options={activitiesList ?? []}
                    disabled={isUploading}
                    optionLabel="name"
                    filter
                    className="custome-dropdown !tw-w-full tw-h-10 sm:tw-h-11 tw-text-sm sm:tw-text-base"
                  />
                )}
              </div>
            </div>
            <div className="tw-pt-4 tw-pb-2 tw-border-b-[1px] tw-border-[#E2E8F0]  ">
              <h2 className="tw-text-lg tw-font-semibold tw-text-[#101828]">
                Pre Entry Checks
              </h2>
            </div>
            <div className="tw-w-full tw-my-4 tw-overflow-x-auto lg:tw-min-w-[600px]">
              <table className="tw-w-full tw-border-collapse">
                <thead>
                  <tr>
                    <th className="tw-text-left tw-p-2 tw-border tw-bg-gray-100">
                      Hazards associated with task
                    </th>
                    <th className="tw-text-left tw-p-2 tw-border tw-bg-gray-100">
                      Yes
                    </th>
                    <th className="tw-text-left tw-p-2 tw-border tw-bg-gray-100">
                      No / NA
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {preEntryChecksData.map((group, groupIndex) => {
                    const hazardRow = data.find(
                      (row) =>
                        row.hazard === group.hazard && row.hazardRowSpan > 0
                    );

                    return (
                      <React.Fragment key={`hazard-${groupIndex}`}>
                        <HazardRow
                          hazard={group.hazard}
                          hazardYes={hazardRow?.hazardYes}
                          hazardNo={hazardRow?.hazardNo}
                          onHazardChange={(value: any) => {
                            // Update local table data
                            setData((prevData) =>
                              prevData.map((row) =>
                                row.hazard === group.hazard
                                  ? {
                                      ...row,
                                      hazardYes: value,
                                      hazardNo: !value,
                                      // If hazard is set to "No", reset all controls to null
                                      controlYes: value ? row.controlYes : null,
                                      controlNo: value ? row.controlNo : null,
                                    }
                                  : row
                              )
                            );

                            // Update form values for validation
                            safeSetFormValues((prevValues: any) => ({
                              ...prevValues,
                              preEntryChecks: prevValues.preEntryChecks.map(
                                (check: any) =>
                                  check.label === group.hazard
                                    ? {
                                        ...check,
                                        value: value ? "yes" : "no",
                                        controlMeasure: value
                                          ? check.controlMeasure
                                          : check.controlMeasure.map(
                                              (cm: any) => ({
                                                ...cm,
                                                value: null,
                                              })
                                            ),
                                      }
                                    : check
                              ),
                            }));
                          }}
                          disabled={isUploading}
                          isPermitSpaceFormAttached={isPermitSpaceFormAttached}
                        />

                        {hazardRow?.hazardYes &&
                          group.controls.map((control, controlIndex) => {
                            const controlRow = data.find(
                              (row) =>
                                row.hazard === group.hazard &&
                                row.control === control
                            );

                            return (
                              <ControlMeasureRow
                                key={`control-${groupIndex}-${controlIndex}`}
                                control={control}
                                controlYes={controlRow?.controlYes}
                                controlNo={controlRow?.controlNo}
                                onControlChange={(value: any) => {
                                  // Update local table data
                                  setData((prevData) =>
                                    prevData.map((row) =>
                                      row.hazard === group.hazard &&
                                      row.control === control
                                        ? {
                                            ...row,
                                            controlYes: value,
                                            controlNo: !value,
                                          }
                                        : row
                                    )
                                  );

                                  // Update form values for validation
                                  safeSetFormValues((prevValues: any) => ({
                                    ...prevValues,
                                    preEntryChecks:
                                      prevValues.preEntryChecks.map(
                                        (check: any) => {
                                          if (check.label === group.hazard) {
                                            return {
                                              ...check,
                                              controlMeasure:
                                                check.controlMeasure.map(
                                                  (controlMeasure: any) =>
                                                    controlMeasure.label ===
                                                    control
                                                      ? {
                                                          ...controlMeasure,
                                                          value: value
                                                            ? "yes"
                                                            : "no",
                                                        }
                                                      : controlMeasure
                                                ),
                                            };
                                          }
                                          return check;
                                        }
                                      ),
                                  }));
                                }}
                                disabled={isUploading}
                                isPermitSpaceFormAttached={
                                  isPermitSpaceFormAttached
                                }
                              />
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="tw-pt-4 tw-pb-2 tw-border-b-[1px] tw-border-[#E2E8F0]  ">
              <h2 className="tw-text-lg tw-font-semibold tw-text-[#101828]">
                Safety Essential Equipment Checks Completed
              </h2>
            </div>

            <div>
              <DataTable
                value={currentFormValues?.safetyEssentialEquipmentCheck || []}
                className="tw-mt-4"
                scrollable
                showGridlines
              >
                <Column
                  field="label"
                  header="Survey Equipment  "
                  style={{ maxWidth: "500px" }}
                />
                <Column
                  field="yes"
                  header="Yes"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.safetyEssentialEquipmentCheck[
                          rowIndex
                        ].value === "yes"
                      }
                      name={`yes-survey-${rowIndex}`}
                      inputId={`yes-survey-${rowIndex}`}
                      className="tw-mr-2"
                      disabled={isUploading || isPermitSpaceFormAttached}
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          safetyEssentialEquipmentCheck:
                            prev.safetyEssentialEquipmentCheck.map(
                              (item: any, index: number) =>
                                index === rowIndex
                                  ? { ...item, value: "yes" }
                                  : item
                            ),
                        }))
                      }
                    />
                  )}
                />
                <Column
                  field="no"
                  header="No / NA"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.safetyEssentialEquipmentCheck[
                          rowIndex
                        ].value === "no"
                      }
                      name={`no-survey-${rowIndex}`}
                      inputId={`no-survey-${rowIndex}`}
                      className="tw-mr-2"
                      disabled={isUploading || isPermitSpaceFormAttached}
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          safetyEssentialEquipmentCheck:
                            prev.safetyEssentialEquipmentCheck.map(
                              (item: any, index: number) =>
                                index === rowIndex
                                  ? { ...item, value: "no" }
                                  : item
                            ),
                        }))
                      }
                    />
                  )}
                />
                {/* <Column
                  field="n_a"
                  header="N/A"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.safetyEssentialEquipmentCheck[
                          rowIndex
                        ].value === "n_a"
                      }
                      name={`n_a-survey-${rowIndex}`}
                      inputId={`n_a-survey-${rowIndex}`}
                      className="tw-mr-2"
                      disabled={isUploading || isPermitSpaceFormAttached}
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          safetyEssentialEquipmentCheck:
                            prev.safetyEssentialEquipmentCheck.map(
                              (item: any, index: number) =>
                                index === rowIndex
                                  ? { ...item, value: "n_a" }
                                  : item
                            ),
                        }))
                      }
                    />
                  )}
                /> */}
              </DataTable>
            </div>
            {isPermitSpaceFormAttached ? (
              <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6 tw-px-4 tw-py-4">
                <div className="tw-flex tw-flex-col tw-items-start tw-gap-2">
                  <p className="leak-detail-label">Site Set Up Photo 1</p>
                  <div>
                    <Image
                      src={getSitePhoto("site_setup-1")}
                      preview
                      alt={`Site Setup Photo 1`}
                      className="tw-w-32 tw-shrink-0 tw-object-contain"
                      indicatorIcon={icon}
                      loading="lazy"
                      // downloadable
                      pt={{
                        rotateRightButton: { className: "tw-text-white" },
                        downloadButton: { className: "tw-text-white" },
                        rotateLeftButton: { className: "tw-text-white" },
                        zoomInButton: { className: "tw-text-white" },
                        zoomOutButton: { className: "tw-text-white" },
                        closeButton: { className: "tw-text-white" },
                      }}
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = ImageNotAvailable;
                      }}
                    />
                    {(getPhotoMeta("site_setup-1").timestamp ||
                      getPhotoMeta("site_setup-1").address) && (
                      <div className="tw-mt-2">
                        <p className="tw-text-sm tw-text-gray-900">
                          {getPhotoMeta("site_setup-1").address}
                        </p>
                        <p className="tw-text-sm tw-text-gray-900">
                          {getPhotoMeta("site_setup-1").timestamp}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="tw-flex tw-flex-col tw-items-start tw-gap-2">
                  <p className="leak-detail-label">Site Set Up Photo 2</p>
                  <div>
                    <Image
                      src={getSitePhoto("site_setup-2")}
                      preview
                      alt={`Site Setup Photo 2`}
                      className="tw-w-32 tw-shrink-0 tw-object-contain"
                      indicatorIcon={icon}
                      loading="lazy"
                      // downloadable
                      pt={{
                        rotateRightButton: { className: "tw-text-white" },
                        downloadButton: { className: "tw-text-white" },
                        rotateLeftButton: { className: "tw-text-white" },
                        zoomInButton: { className: "tw-text-white" },
                        zoomOutButton: { className: "tw-text-white" },
                        closeButton: { className: "tw-text-white" },
                      }}
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = ImageNotAvailable;
                      }}
                    />
                    {(getPhotoMeta("site_setup-2").timestamp ||
                      getPhotoMeta("site_setup-2").address) && (
                      <div className="tw-mt-2">
                        <p className="tw-text-sm tw-text-gray-900">
                          {getPhotoMeta("site_setup-2").address}
                        </p>
                        <p className="tw-text-sm tw-text-gray-900">
                          {getPhotoMeta("site_setup-2").timestamp}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="tw-grid tw-grid-cols-1 tw-mt-6 xl:tw-grid-cols-2 tw-gap-6 tw-w-full">
                <div className="tw-flex tw-flex-col  tw-gap-1 tw-items-start tw-justify-start">
                  <PhotoUpload
                    label={"Site Set Up Photo 1"}
                    name="site_setup-1"
                    images={currentImages}
                    isUploadInProgress={
                      (isUploadInProgress
                        ? isUploadInProgress
                        : isSiteSetupUploadInProgress) ||
                      isPermitSpaceFormAttached
                    }
                    setIsUploadInProgress={
                      setIsUploadInProgress
                        ? setIsUploadInProgress
                        : setIsSiteSetupUploadInProgress
                    }
                    setImages={safeSetImages}
                    fileValues={currentFileValues}
                    setFileValues={safeSetFileValues}
                    timeStampLocationValues={currentTimeStampLocationValues}
                    setTimeStampLocationValues={safeSetTimeStampLocationValues}
                    classname="tw-w-full"
                  />
                </div>
                <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start ">
                  <PhotoUpload
                    label={"Site Set Up Photo 2"}
                    name="site_setup-2"
                    images={currentImages}
                    isUploadInProgress={
                      (isUploadInProgress
                        ? isUploadInProgress
                        : isSiteSetupUploadInProgress) ||
                      isPermitSpaceFormAttached
                    }
                    setIsUploadInProgress={
                      setIsUploadInProgress
                        ? setIsUploadInProgress
                        : setIsSiteSetupUploadInProgress
                    }
                    setImages={safeSetImages}
                    fileValues={currentFileValues}
                    setFileValues={safeSetFileValues}
                    timeStampLocationValues={currentTimeStampLocationValues}
                    setTimeStampLocationValues={safeSetTimeStampLocationValues}
                    classname="tw-w-full"
                  />
                </div>
              </div>
            )}
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-mt-3 tw-gap-3 tw-w-full">
              <div className="tw-flex tw-flex-col tw-mt-8 tw-gap-1 tw-items-start tw-justify-start tw-w-full">
                <label className="leak-label" htmlFor="permitClosureReason">
                  Permit Closure Reason
                </label>
                {isPermitSpaceFormAttached ? (
                  <InputText
                    type="text"
                    value={currentFormValues?.permitClosureReason || "N/A"}
                    readOnly
                    className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  />
                ) : (
                  <Dropdown
                    id="permitClosureReason"
                    placeholder="Select permit closure reason"
                    disabled={isUploading}
                    value={currentSelectedPermitClosureReason}
                    onChange={(e) => {
                      safeSetSelectedPermitClosureReason(e.value);
                      safeSetFormValues((prevValues: any) => ({
                        ...prevValues,
                        permitClosureReason: e.value.reason,
                      }));
                      if (e.value.reason !== "Confined Spaces Aborted") {
                        safeSetFormValues((prevValues: any) => ({
                          ...prevValues,
                          commentsIfAny: null,
                        }));
                      }
                    }}
                    options={permitClosureReasonList ?? []}
                    optionLabel="reason"
                    filter
                    className="custome-dropdown !tw-w-full tw-h-10 sm:tw-h-11 tw-text-sm sm:tw-text-base"
                  />
                )}
              </div>
              {currentFormValues?.permitClosureReason ===
                "Confined Spaces Aborted" && (
                <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span tw-mt-3">
                  <label className="leak-label">Comments If Any: </label>
                  <InputTextarea
                    rows={1}
                    value={currentFormValues.commentsIfAny ?? ""}
                    onChange={(e) =>
                      safeSetFormValues((prevValues: any) => ({
                        ...prevValues,
                        commentsIfAny: e.target.value,
                      }))
                    }
                    readOnly={isPermitSpaceFormAttached}
                    disabled={isUploading}
                    placeholder="Enter Comments If Any: "
                    className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-w-full"
                  />
                </div>
              )}
            </div>
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-mt-3 tw-gap-3 tw-w-full">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Permit Start date and Time</label>
                {isPermitSpaceFormAttached ? (
                  <InputText
                    type="text"
                    value={
                      formatDateTime(
                        currentFormValues?.permitStartDateAndTime
                      ) || "N/A"
                    }
                    readOnly
                    className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  />
                ) : (
                  <Calendar
                    value={getDisplayDate(currentSelectedPermitStartDateTime)}
                    onChange={(e) => {
                      safeSetSelectedPermitStartDateTime(e.value);
                      handleTimeChange("permitStartDateAndTime", e.value);
                    }}
                    placeholder="Select Permit Start Date/Time"
                    showTime
                    dateFormat="dd-mm-yy"
                    hourFormat="24"
                    className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  />
                )}
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Permit End Date and Time</label>
                {isPermitSpaceFormAttached ? (
                  <InputText
                    type="text"
                    value={
                      formatDateTime(currentFormValues?.permitEndDateAndTime) ||
                      "N/A"
                    }
                    readOnly
                    className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  />
                ) : (
                  <Calendar
                    value={getDisplayDate(currentSelectedPermitEndDateTime)}
                    onChange={(e) => {
                      safeSetSelectedPermitEndDateTime(e.value);
                      handleTimeChange("permitEndDateAndTime", e.value);
                    }}
                    placeholder="Select Permit End Date/Time"
                    showTime
                    hourFormat="24"
                    dateFormat="dd-mm-yy"
                    className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  />
                )}
              </div>
            </div>
            <div className="tw-pt-4 tw-pb-2 tw-border-b-[1px] tw-border-[#E2E8F0] tw-mt-4 ">
              <h2 className="tw-text-lg tw-font-semibold tw-text-[#101828]">
                ACKNOWLEDMENT and Approval of Permit (All Personnel)
              </h2>
            </div>
            <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 ">
              {envUsers && !isStandaloneMode && (
                <>
                  <EnvSignaturesInPermit
                    teamMember1={
                      // currentFormValues?.name.find(
                      //   (n: any) =>
                      //     n.userID?.toString() ===
                      //     teamMember1?.userID?.toString()
                      // )
                      //   ? isPermitSpaceFormAttached
                      //     ? {}
                      //     : teamMember1
                      //   : teamMember1
                      isPermitSpaceFormAttached ? {} : teamMember1
                    }
                    teamMember2={isPermitSpaceFormAttached ? {} : teamMember2}
                    additionalTeamMembers={
                      // additionalTeamMembers?.length &&
                      // additionalTeamMembers.some((tm: any) =>
                      //   currentFormValues?.name.some(
                      //     (n: any) =>
                      //       n.userID?.toString() === tm?.userID?.toString()
                      //   )
                      // )
                      //   ? isPermitSpaceFormAttached
                      //     ? []
                      //     : additionalTeamMembers
                      //   : additionalTeamMembers
                      isPermitSpaceFormAttached ? [] : additionalTeamMembers
                    }
                    currentFormValues={currentFormValues}
                    signatureDataURLs={signatureDataURLs}
                    envEntrantTopmans={envEntrantTopmans}
                    setEnvEntrantTopmans={setEnvEntrantTopmans}
                    type="approvalOfPermit"
                  />
                </>
              )}
              {isPermitSpaceFormAttached ? (
                <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-4 tw-gap-6 tw-w-full tw-mt-5 tw-px-4">
                  {approvalSignatures?.map((signature: any, index: number) => {
                    const userID = signature.originalname.split("_")[0];
                    const user = currentFormValues.name.find(
                      (person: any) => person.userID.toString() === userID
                    );

                    return (
                      <div
                        key={index}
                        className="tw-flex tw-flex-col tw-items-start tw-gap-1"
                      >
                        <div className="tw-flex tw-items-center tw-gap-2 tw-justify-between tw-w-full">
                          <p className="leak-detail-label tw-text-black tw-max-w-[60%] tw-truncate">
                            {user?.displayName || "Unknown User"}
                          </p>
                          <p className="tw-text-sm">
                            {formatDate(currentFormValues.date)}
                          </p>
                        </div>
                        <img
                          src={signature.file}
                          alt={`${user?.displayName || "User"} signature`}
                          className="tw-w-full tw-max-h-32 tw-shrink-0 tw-object-contain tw-border"
                        />
                        <p className="leak-detail-label tw-text-black tw-truncate tw-w-full">
                          {user?.displayName || "Unknown User"}
                        </p>
                        {
                          <p className="tw-text-normal tw-text-gray-800">
                            Entrant/Topman:{" "}
                            <span className="tw-font-medium tw-text-gray-600">
                              {getEntrantTopman(user, "approvalOfPermit")}
                            </span>
                          </p>
                        }
                      </div>
                    );
                  })}
                </div>
              ) : (
                <PermitSignaturesComponent
                  users={
                    envUsers
                      ? currentFormValues.name.filter(
                          (prevMember: any) =>
                            !envUsers.some(
                              (current: any) =>
                                current.userID === prevMember.userID
                            )
                        )
                      : currentFormValues.name
                  }
                  formValues={currentFormValues}
                  setFormValues={safeSetFormValues}
                  usersRefs={currentPermitApprovalRefs}
                  isPermitSpaceFormAttached={isPermitSpaceFormAttached}
                  textToShow={`${
                    isPermitSpaceFormAttached
                      ? "Please select team members from DRA form."
                      : "Please selecte users/names for signature"
                  }`}
                  setPermitFiles={setPermitSignatureFiles}
                  isStandaloneMode={isStandaloneMode}
                  type="approvalOfPermit"
                />
              )}
            </div>
            <div className="tw-pt-4 tw-pb-2 tw-border-b-[1px] tw-border-[#E2E8F0] tw-mt-4 ">
              <h2 className="tw-text-lg tw-font-semibold tw-text-[#101828]">
                ACKNOWLEDMENT OF Permit Closure (All Personnel)
              </h2>
            </div>
            <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 ">
              {currentFormValues.name.length === 0 && (
                <div>
                  <span>Please select a user for Permit Closure.</span>
                </div>
              )}
              {envUsers && !isStandaloneMode && (
                <>
                  <EnvSignaturesInPermit
                    teamMember1={isPermitSpaceFormAttached ? {} : teamMember1}
                    teamMember2={isPermitSpaceFormAttached ? {} : teamMember2}
                    additionalTeamMembers={
                      isPermitSpaceFormAttached ? [] : additionalTeamMembers
                    }
                    currentFormValues={currentFormValues}
                    signatureDataURLs={signatureDataURLs}
                    envEntrantTopmans={envEntrantTopmans}
                    setEnvEntrantTopmans={setEnvEntrantTopmans}
                    type="permitClosure"
                  />
                </>
              )}
              {isPermitSpaceFormAttached ? (
                <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-4 tw-gap-6 tw-w-full tw-mt-5 tw-px-4">
                  {closureSignatures?.map((signature: any, index: number) => {
                    const userID = signature.originalname.split("_")[0];
                    const user = currentFormValues.name.find(
                      (person: any) => person.userID.toString() === userID
                    );

                    return (
                      <div
                        key={index}
                        className="tw-flex tw-flex-col tw-items-start tw-gap-1"
                      >
                        <div className="tw-flex tw-items-center tw-gap-2 tw-justify-between tw-w-full">
                          <p className="leak-detail-label tw-text-black tw-max-w-[60%] tw-truncate">
                            {user?.displayName || "Unknown User"}
                          </p>
                          <p className="tw-text-sm">
                            {formatDate(currentFormValues.date)}
                          </p>
                        </div>
                        <img
                          src={signature.file}
                          alt={`${user?.displayName || "User"} signature`}
                          className="tw-w-full tw-max-h-32 tw-shrink-0 tw-object-contain tw-border"
                        />
                        <p className="leak-detail-label tw-text-black tw-truncate tw-w-full">
                          {user?.displayName || "Unknown User"}
                        </p>
                        {
                          <p className="tw-text-normal tw-text-gray-800">
                            Entrant/Topman:{" "}
                            <span className="tw-font-medium tw-text-gray-600">
                              {getEntrantTopman(user, "permitClosure")}
                            </span>
                          </p>
                        }
                      </div>
                    );
                  })}
                </div>
              ) : (
                <PermitSignaturesComponent
                  users={
                    envUsers
                      ? currentFormValues.name.filter(
                          (prevMember: any) =>
                            !envUsers.some(
                              (current: any) =>
                                current.userID === prevMember.userID
                            )
                        )
                      : currentFormValues.name
                  }
                  formValues={currentFormValues}
                  setFormValues={safeSetFormValues}
                  usersRefs={currentPermitClosureRefs}
                  isPermitSpaceFormAttached={isPermitSpaceFormAttached}
                  textToShow={`${
                    isPermitSpaceFormAttached
                      ? "Please select team members from DRA form."
                      : "Please selecte users/names for signature"
                  }`}
                  setPermitFiles={setPermitSignatureFiles}
                  isStandaloneMode={isStandaloneMode}
                  type="permitClosure"
                />
              )}
            </div>
          </div>

          {isStandaloneMode && (
            <div className="tw-flex tw-justify-end tw-items-center tw-p-4  tw-gap-2 !tw-border-t-[#E2E8F0] tw-border-t-[1px]">
              <Button
                className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-border-solid tw-border focus:tw-shadow-none  !tw-border-[#344054] tw-text-[#344054] tw-font-medium"
                label="Cancel"
                disabled={isUploading}
                onClick={() =>
                  navigate(
                    "/layout/health-and-safety/permit-for-confined-space-entry"
                  )
                }
                color="white"
              />
              <Button
                className="tw-flex tw-px-3 focus:tw-shadow-none tw-py-2 tw-rounded tw-bg-primary tw-border-primary tw-text-white tw-font-medium"
                label={`${formSubmitting ? "Saving..." : "Save"}`}
                loading={formSubmitting}
                disabled={isUploading}
                onClick={handleSave}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddPermitSpaceEntryForm;
